export default function Header2({ children }) {
  return (
    <h4 className='text-medium-large md:text-large font-bold uppercase md:mb-8 mb-4'>
        {children}
    </h4>
  )
}
